import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import './top.css'

function Top(){
  return(
    <Fragment>
      <div className='top-container topfix'>
        <div className='center960 flex-row-end'>
          <Link to='/' className='topLink'>首 页</Link>
          <Link to='/company' className='topLink'>企业简介</Link> 
          <Link to='/product' className='topLink'>产品中心</Link>
          <Link to='/customer' className='topLink'>客户案例</Link>
          <Link to='/contact' className='topLink'>联系我们</Link>
        </div>
      </div>
      <div className='top-container'></div>
    </Fragment>
  )
}
export default Top;